import {ChangeEvent, FormEvent, useEffect, useRef, useState} from 'react'
import {BASE_URL} from '../../config'
import {useMutation, useQueryClient} from 'react-query'
import axios from 'axios'
import toast from 'react-hot-toast'
import {handleAxiosError} from '../../../utils/helperFunction/_helper'
import {Role} from './_model'

type Props = {
  selectedRole: Role | null
  refetch: () => void
  onReset: () => void
}

const CREATE_ROLE_URL = `${BASE_URL}/api/protect/createUserRole`
const UPDATE_ROLE_URL = `${BASE_URL}/api/protect/updateRole`

const RoleForm = ({selectedRole, refetch, onReset}: Props) => {
  const queryClient = useQueryClient()
  const [rolename, setRolename] = useState('')

  const inputRef = useRef<HTMLInputElement>(null)

  const onRolenameChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setRolename(value)
  }

  const {mutateAsync: roleSubmit} = useMutation({
    mutationFn: async () => {
      toast.loading('Processing..')
      if (selectedRole) {
        await axios.put(UPDATE_ROLE_URL, {idLevel: selectedRole.id_level, levelName: rolename})
      } else {
        await axios.post(CREATE_ROLE_URL, {levelName: rolename})
      }
    },
    onSuccess: () => {
      toast.dismiss()
      toast.success('Successfully done')
      queryClient.invalidateQueries(['userRole'])
      refetch()
      setRolename('')
      onReset()
    },
    onError: (error: Error) => {
      console.log(error)
      const message = handleAxiosError(error)
      toast.dismiss()
      toast.error(message)
    },
  })

  const onSubmitRoleForm = async (e: FormEvent) => {
    e.preventDefault()

    try {
      await roleSubmit()
    } catch (error) {
      const message = handleAxiosError(error)
      toast.dismiss()
      toast.error(message)
      console.log(error)
    }
  }

  const reset = () => {
    setRolename('')
    onReset()
  }

  useEffect(() => {
    setRolename('')
    if (selectedRole) {
      setRolename(selectedRole.level_name)
      inputRef.current?.focus()
    }
  }, [selectedRole])

  return (
    <div className='w-100 mw-500px'>
      <form onSubmit={onSubmitRoleForm}>
        <div className='d-flex gap-4 flex-wrap'>
          <div className='col'>
            <div className='fv-row mb-7'>
              <label className='fw-semibold fs-6 mb-2 required'>Role Name</label>

              <input
                ref={inputRef}
                placeholder='Enter value'
                type='text'
                name='rolename'
                className={`form-control form-control custom-input mb-3 mb-lg-0 ${
                  selectedRole && 'border-info'
                }`}
                value={rolename}
                onChange={onRolenameChange}
                autoComplete='off'
                required
              />
            </div>
          </div>

          <div className='col'>
            <div className='mt-9'>
              <button type='reset' className='btn btn-light me-3' onClick={reset}>
                Reset
              </button>
              <button type='submit' className='btn btn-primary' data-kt-users-modal-action='submit'>
                <span className='indicator-label'>{selectedRole ? 'Update' : 'Create'}</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default RoleForm
